import {
  useReactMutation,
  useTranslation,
  getPostServicePromise
} from '@invision/core';
import type {
  SecurityResetPasswordConfirmationRequest,
  SecurityResetPasswordConfirmationResponse
} from 'invApi';

/**
 * Hook for validating password reset token
 * Creates temporary session for password update
 *
 * API: POST Security/ResetPasswordConfirmation
 * Headers: None (unauthenticated)
 * Returns: SessionId (JWT) for subsequent API calls
 */
export function useResetPasswordConfirmationMutation() {
  const { t } = useTranslation();

  return useReactMutation<
    SecurityResetPasswordConfirmationResponse,
    SecurityResetPasswordConfirmationRequest
  >(
    ['resetPasswordConfirmation'],
    (request: SecurityResetPasswordConfirmationRequest) =>
      getPostServicePromise(
        { path: 'Security/ResetPasswordConfirmation' },
        {
          payload: request,
          faults: {
            '108': t('Email failed to send'),
            '111': t('User not found'),
            '121': t('Password is locked and cannot be changed'),
            '154': t('Invalid or expired reset token'),
            '158': t('Reset token has expired')
          }
        }
      ),
    {},
    {
      useLoadingIndicator: true
    }
  );
}
